import type {
  SensitiveActionAuthorizationDetails,
  SensitiveActionAuthorizationRequest,
} from "./SensitiveActionAuthorization";

export function createSensitiveActionAuthorizationController(
  onPendingRequestChange: (request: SensitiveActionAuthorizationRequest | null) => void,
) {
  let resolver: ((details: SensitiveActionAuthorizationDetails | null) => void) | null = null;
  let activePromise: Promise<SensitiveActionAuthorizationDetails | null> | null = null;

  const settleAuthorization = (details: SensitiveActionAuthorizationDetails | null) => {
    resolver?.(details);
    resolver = null;
    activePromise = null;
    onPendingRequestChange(null);
  };

  const requestAuthorization = (request: SensitiveActionAuthorizationRequest) => {
    if (activePromise) {
      return Promise.resolve(null);
    }

    const promise = new Promise<SensitiveActionAuthorizationDetails | null>((resolve) => {
      resolver = resolve;
    });
    activePromise = promise;
    onPendingRequestChange(request);

    return promise;
  };

  const cancelPendingAuthorization = () => {
    settleAuthorization(null);
  };

  return {
    cancelPendingAuthorization,
    requestAuthorization,
    settleAuthorization,
  };
}
